import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const invoiceDeliveryOptionsAdapter = getAdapter({ idFieldName: 'value' });

const invoiceDeliveryOptionsSlice = createSlice({
  name: 'invoiceDeliveryOptions',
  initialState: invoiceDeliveryOptionsAdapter.getInitialState(),
  reducers: {
    setInvoiceDeliveryOptions: (state, { payload: { invoiceDeliveryOptions } }) => {
      invoiceDeliveryOptionsAdapter.setAll(state, invoiceDeliveryOptions);
    },
  },
});

const selectors = invoiceDeliveryOptionsAdapter.getSelectors(({ invoiceDeliveryOptions }) => invoiceDeliveryOptions);

export const getInvoiceDeliveryOptions = (state) => selectors.selectAll(state);

export const {
  setInvoiceDeliveryOptions,
} = invoiceDeliveryOptionsSlice.actions;

export default invoiceDeliveryOptionsSlice.reducer;
